export const ADMIN_ROUTE = "/admin"
export const OPTIONS_ROUTE = "/options"
export const BOARD_ROUTE = "/"

export const matchRoute = (url, route) => {
  const match = url.pathname === route
  console.debug("Testing route", url, route, match)
  return match
}
